import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useCheckInAttendeeMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: Api.IEventRegistrationSurveyResponse) => void;
}) => {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			responseId,
			attendeeIndex,
			status,
		}: {
			responseId: string;
			attendeeIndex: number;
			status: Api.CheckInStatus;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IEventRegistrationSurveyResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/eventRegistration/response/${responseId}/attendee/${attendeeIndex}/checkInStatus`,
				}),
				'PUT',
				status
			);
		},
		onSuccess: data => {
			// Invalidate and refetch queries to get fresh data
			queryClient.invalidateQueries({ queryKey: ['survey/eventRegistration/response/filter'] });
			queryClient.invalidateQueries({ queryKey: ['eventRegistrationStats'] });
			queryClient.refetchQueries({ queryKey: ['survey/eventRegistration/response/filter'], type: 'active' });

			onSuccess?.(data);
		},
		onError,
	});
};
